import {
  AgentExecutionStatusSchema,
  ExecutionSchema,
  ExecutionTypeSchema,
  PlanItemSchema as PlanItemSchemaGenerated,
  PlanItemStatusSchema as PlanItemStatusSchemaGenerated,
  TargetTypeSchema,
} from '@terra/shared-schemas-ai';
import { z } from 'zod';

export const PlanItemSchema = PlanItemSchemaGenerated;
export const PlanItemStatusSchema = PlanItemStatusSchemaGenerated;

export type PlanItemStatusType = z.infer<typeof PlanItemStatusSchema>;

export type PlanItemDto = z.infer<typeof PlanItemSchema>;

export const AgentExecutionSchema = ExecutionSchema.extend({
  executionType: ExecutionTypeSchema,
  plan: PlanItemSchemaGenerated.array(),
});

const stringBooleanSchema = z
  .union([z.boolean(), z.string()])
  .transform((val) => {
    if (typeof val === 'boolean') return val;

    return val === 'true';
  });

export const AGENT_EXECUTION_ORDER_BY_FIELDS = [
  'createdAt',
  'status',
  'duration',
] as const;

export const AgentExecutionOrderByFieldSchema = z.enum(
  AGENT_EXECUTION_ORDER_BY_FIELDS,
);

export const AgentExecutionOrderBySchema = z.object({
  field: AgentExecutionOrderByFieldSchema,
  order: z.enum(['asc', 'desc']),
});

const AgentExecutionStatusFilterSchema = z
  .union([AgentExecutionStatusSchema, AgentExecutionStatusSchema.array()])
  .transform((value) => (Array.isArray(value) ? value : [value]));

export const AgentExecutionCountQuerySchema = z.object({
  archived: stringBooleanSchema.optional(),
  executionType: ExecutionTypeSchema.optional(),
  search: z.string().trim().max(200).optional(),
  startDate: z.coerce.date().optional(),
});

export const FindByTargetQuerySchema = AgentExecutionCountQuerySchema.extend({
  scanId: z.string().optional(),
  status: AgentExecutionStatusFilterSchema.optional(),
  orderBy: AgentExecutionOrderBySchema.array().optional(),
  skip: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
});

export const AGENT_EXECUTION_BULK_MAX_IDS = 500;

export const AgentExecutionBulkBodySchema = z.object({
  executionIds: z.array(z.string()).min(1).max(AGENT_EXECUTION_BULK_MAX_IDS),
});

export const AgentExecutionBulkResponseSchema = z.object({
  succeededIds: z.array(z.string()),
  skippedIds: z.array(z.string()),
});

export const FindByTargetTypeQuerySchema = z.object({
  targetType: TargetTypeSchema,
  archived: stringBooleanSchema.optional(),
  status: AgentExecutionStatusSchema.optional(),
  skip: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
});

export const FindByTargetResponseSchema = z.object({
  executions: z.array(AgentExecutionSchema),
  totalCount: z.number(),
});

export const CountByStatusResponseSchema = z.record(
  AgentExecutionStatusSchema,
  z.number(),
);
